import { render, staticRenderFns } from "./AddAirplaneModal.vue?vue&type=template&id=6026c380&"
import script from "./AddAirplaneModal.vue?vue&type=script&lang=js&"
export * from "./AddAirplaneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/opt/buildhome/repo/components/global/Button.vue').default,Modal: require('/opt/buildhome/repo/components/global/Modal/index.vue').default})
